import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResumeDataByID } from '@edtech-ui/core/models/resume-builder/get-resume-by-id';

@Component({
  selector: 'app-modern',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modern.component.html',
  styleUrl: './modern.component.scss'
})
export class ModernComponent {

  @Input() data!: ResumeDataByID;
  @Input() color:string= '#4f46e5';
  @Input() font: string = 'Inter'
    
}
